// app/stores/webappStore.ts

import type { TwitchInfo } from "~/src/twitch/domain/models/TwitchInfo";
import type { HeaderButtonsSetup } from "~/src/options/domain/models/CmsOptions";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import { useTwitch } from "~/app/composables/twitch";

export const useWebappStore = defineStore("webappStore", () => {
  const competitionStore = useCompetitionStore();
  const { getTwitchInfo } = useTwitch();

  const setActiveRegion = (): string => {
    const route = useRoute();
    return route.params.region
      ? (route.params.region as string)
      : competitionStore.region
        ? competitionStore.region.slug
        : "espana";
  };

  const activeRegion = ref<string>(setActiveRegion());
  const regionHovered = ref<string | undefined>(setActiveRegion());
  const navCompetitionHovered = ref<string | undefined>();
  const hoveringMegaMenu = ref<boolean>();
  const twitchInfo = ref<TwitchInfo | undefined>();
  const headerButtonsData = ref<HeaderButtonsSetup | undefined>();

  const updateTwitchStatus = async (locale: string): Promise<void> => {
    const region = activeRegion.value === "king-of-kings" ? "espana" : activeRegion.value;
    const twitchData = await getTwitchInfo(region, locale);
    if (twitchInfo) {
      twitchInfo.value = twitchData;
    }
  };

  if (import.meta.client) {
    watchEffect(() => {
      if (hoveringMegaMenu.value === false) {
        regionHovered.value = activeRegion.value;
      }
    });
  }

  return {
    activeRegion,
    regionHovered,
    navCompetitionHovered,
    hoveringMegaMenu,
    twitchInfo,
    headerButtonsData,
    setActiveRegion,
    updateTwitchStatus,
  };
});
